import React, { useEffect, useState } from "react";
import { BackgroundATADashboard } from "./style";
import { removeError, showNavBar } from "../../_store/_actions/uiActions";
import { useDispatch } from "react-redux";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ApplyEcosToken from "./ApplyEcosToken";
import ApplyWalletTransaction from "./ApplyWalletTransation";
import AddWalletPartner from "./AddWalletPartner";

const ATADashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showNavBar());
    dispatch(removeError());
  }, []);

  return (
    <>
      <BackgroundATADashboard>
        <div className="row">
          <div className="row col-md-12 divcenter">
            <div className="col-md-3">
              <div className="title">
                <h2>Dashboard</h2>
              </div>
            </div>
            <div className="col-md-8">
              <span>
                In this section of your <b>SHARED ECONOMY Partner Portal</b> you
                will find everything related to your <b>ECO's, Air ECO's</b> and{" "}
                <b>Cashable USD.</b>
                Review your ECO's usage history and keep track of your past and
                future Air ECO's earnings. If you decide to do so, transfer any
                amount of your Cashable USD balance to pay off your{" "}
                <b>REEF Hotels Membership.</b>
              </span>
            </div>
          </div>
        </div>

        <div className="container-fluid pt-4">
          <Tabs
            defaultActiveKey="wallet"
            transition={false}
            id="noanim-tab-example"
          >
            <Tab eventKey="partner" title="Add Partner">
              <AddWalletPartner />
            </Tab>
            <Tab eventKey="token" title="Apply Eco Token">
              <ApplyEcosToken />
            </Tab>
            <Tab eventKey="wallet" title="Apply Wallet Transaction">
              <ApplyWalletTransaction />
            </Tab>
          </Tabs>
        </div>
      </BackgroundATADashboard>
    </>
  );
};

export default ATADashboard;
